import React from 'react'
import {Map as ReactMapGL} from 'react-map-gl/maplibre'
import {MAP_NAME, MAP_REGION} from 'consts'
import {getMapStyle} from 'utils'
import {MapProps} from './MapProps'

export default function Map({
  children,
  viewportState,
  attributionControl = false,
  validateStyle = false,
  reuseMaps = false,
  maxPitch = 0,
  bearing = 0,
  mapRef,
  ...props
}: MapProps) {
  const [viewport, setViewport] = viewportState

  return (
    <ReactMapGL
      {...viewport}
      ref={mapRef}
      reuseMaps={reuseMaps}
      bearing={bearing}
      maxPitch={maxPitch}
      validateStyle={validateStyle}
      attributionControl={attributionControl}
      mapStyle={getMapStyle(
        MAP_REGION,
        MAP_NAME,
        String(process.env.AWS_LOCATION_API_KEY),
      )}
      onMove={(port) => setViewport((prev) => ({...prev, ...port.viewState}))}
      {...props}>
      {children}
    </ReactMapGL>
  )
}
